import { render } from "./NpsScoreRankBody.vue?vue&type=template&id=37221e95"
import script from "./NpsScoreRankBody.vue?vue&type=script&lang=js"
export * from "./NpsScoreRankBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__